import { render, staticRenderFns } from "./NewStationView.vue?vue&type=template&id=bdef2054"
import script from "./NewStationView.vue?vue&type=script&lang=ts"
export * from "./NewStationView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports